import type { RouteRecordRaw } from 'vue-router';
import { lazyPage } from '@/router/lazyPage';

export const silsilahRoutes: RouteRecordRaw[] = [
  {
    path: 'dashboard',
    name: 'silsilah-dashboard',
    component: lazyPage(() => import('./pages/DashboardPage.vue')),
  },
  {
    path: 'users',
    name: 'silsilah-users',
    component: lazyPage(() => import('./pages/UsersPage.vue')),
  },
  {
    path: 'hierarchy-batak',
    name: 'silsilah-hierarchy-batak',
    component: lazyPage(() => import('./pages/HierarchyBatakPage.vue')),
  },
  {
    path: 'hierarchy-batak/:id/edit',
    name: 'silsilah-hierarchy-batak-edit',
    component: lazyPage(() => import('./pages/HierarchyBatakEditPage.vue')),
  },
  {
    path: 'hierarchy-batak/:id',
    name: 'silsilah-hierarchy-batak-focus',
    component: lazyPage(() => import('./pages/HierarchyBatakPage.vue')),
  },
  {
    path: 'contents',
    name: 'silsilah-contents',
    component: lazyPage(() => import('./pages/ContentsPage.vue')),
  },
  {
    path: 'users/:userId/contents',
    name: 'silsilah-user-contents',
    component: lazyPage(() => import('./pages/ContentsPage.vue')),
  },
  {
    path: 'contents/:id',
    name: 'silsilah-content-detail',
    component: lazyPage(() => import('./pages/ContentEditorPage.vue')),
  },
  {
    path: 'config/remote',
    name: 'silsilah-config-remote',
    component: lazyPage(() => import('@/features/config/pages/RemoteConfigPage.vue')),
  },
  {
    path: 'config/data',
    name: 'silsilah-config-data',
    component: lazyPage(() => import('@/features/config/pages/ConfigDataPage.vue')),
  },
  {
    path: 'config/data/tarombo-sync',
    name: 'silsilah-config-data-tarombo-sync',
    component: lazyPage(() => import('@/features/config/pages/TaromboDataSyncPage.vue')),
  },
  {
    path: 'settings',
    name: 'silsilah-settings',
    component: lazyPage(() => import('@/features/settings/pages/SettingsPage.vue')),
  },
];
